import React, { useState, useEffect } from "react";
import "./GitHubContributions.css";
import axios from "axios";

const GitHubContributions = ({ username }) => {
  const [contributionData, setContributionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [contributionCells, setContributionCells] = useState([]);
  const [totalContibutions, setTotalContributions] = useState(0);

  useEffect(() => {
    const fetchContributions = async () => {
      setLoading(true);
      setError(null);

      try {
        const userRes = await axios.get(`https://api.github.com/users/${username}`);

        const year = new Date().getFullYear();

        const contribRes = await axios.get(
          `https://github-contributions-api.jogruber.de/v4/${username}?y=${year}`
        );

        const contributions = Array.isArray(contribRes.data?.contributions)
          ? contribRes.data.contributions
          : [];

          contributions.sort(
            (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
          );

          const today = new Date();
          const ytd = contributions.filter((c) => new Date(c.date) <= today);

          const levels = ytd.map((c) => Number(c.level ?? 0));

          while (levels.length < 371) levels.push(0);

          const finalCells = levels.slice(0, 371);

          const total = ytd.reduce((sum, c) => sum + Number(c.count ?? 0), 0);

          setContributionCells(finalCells);
          setTotalContributions(total);

          setContributionData({
            ...userRes.data,
            profileUrl: userRes.data.html_url,
            year,
          });

          setLoading(false);
      } catch (e) {
        console.error("Error fetching GitHub data:", e);
        setError("Failed to load GitHub contributions. Please try again later.");
        setLoading(false);
      }
    };

    if (username) fetchContributions();
  }, [username]);

  if (loading) return <div className = "github-loading">Loading contribution data . . .</div>;
  if (error) return <div className = "github-error">{error}</div>;
  if (!contributionData) return null;

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  return (
    <div className = "github-contributions-container">
      <div className = "contribution-header">
        <h3>
          <span>GitHub Contributions</span>
        </h3>
      </div>

      <div className = "months-container">
        {months.map((m) => (
          <div key = {m} className = "month-label">
            {m}
          </div>
        ))}
      </div>

      <div className = "days-container">
        <div className = "day-labels">
          <span>Mon</span>
          <span>Wed</span>
          <span>Fri</span>
        </div>

        <div className = "embed-container">
          <div className = "contributions-grid">
            {contributionCells.map((level, index) => (
              <div
                key = {index}
                className = {`contribution-cell contribution-level-${level}`}
                title = {`${level} level`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className = "contribution-summary">
        <div className = "contribution-count">
          {totalContibutions} contributions in {contributionData.year} (YTD) .{" "}
          <a href = {contributionData.profileUrl} target = "_blank" rel = "noopener noreferrer">
            View Profile
          </a>
        </div>

        <div className = "contribution-legend">
          <span className = "contribution-legend-text"></span>
          <div className = "legend-item contribution-level-0"></div>
          <div className = "legend-item contribution-level-1"></div>
          <div className = "legend-item contribution-level-2"></div>
          <div className = "legend-item contribution-level-3"></div>
          <div className = "legend-item contribution-level-4"></div>
          <span className = "contribution-legend-text"></span>
        </div>
      </div>
    </div>
  );
};

export default GitHubContributions;